const en = {
  // Header
  changePassword: 'Change Password',
  logout: 'Logout',
  darkMode: 'Dark Mode',
  lightMode: 'Light Mode',

  // Tabs
  tabData: 'Data & Competitions',
  tabDashboard: 'Dashboard',
  tabAdmin: 'Administration',

  // Header-Buttons
  btnImages: 'Images',
  btnMaintenance: 'Data Maintenance',

  // Import-Karten
  importSubmissions: 'Import Submissions',
  importSubmissionsHint: 'Import multi-sheet Excel with Acceptance/HM/Medal values',
  importResults: 'Import former Results',
  importResultsHint: 'Use this once to import existing competition results as a matrix Excel. Add new results going forward via "Add Result".',
  importCompetitions: 'Import Competition List',
  importCompetitionsHint: 'Import official competition list',
  deleteOwnData: 'Delete own data first (re-import)',
  replaceSubmissions: 'Replace submissions (re-import)',
  clearTable: 'Clear table first (re-import)',
  selectFile: 'Select File',
  importing: 'Importing...',
  templateDownload: 'Template',

  // Wettbewerbe suchen
  searchCompetitions: 'Search Competitions',
  salonName: 'Salon Name',
  fiapNumber: 'FIAP Number',
  closingFromTo: 'Closing from – to',
  search: 'Search',
  noResults: 'No competitions found.',
  results: 'Result',
  details: 'Details',
  less: 'less',

  // Ergebnis hinzufügen
  addResult: 'Add Result',
  selectImage: 'Select Image:',
  existingImage: '-- existing image --',
  newImage: 'Or new image:',
  newImageTitle: 'New image title',
  selectFromFiap: 'Select from FIAP list:',
  salonNameLabel: 'Salon Name:',
  fiapNumberLabel: 'FIAP Number:',
  country: 'Country:',
  searchCountry: 'Search country...',
  salonType: 'Salon Type:',
  resultLabel: 'Result:',
  save: 'Save',
  saving: 'Saving...',
  exportCsv: 'Export CSV',

  // Dashboard
  distinction: 'Distinction:',
  overview: 'Overview',
  required: 'Required',
  progress: 'Progress',
  acceptances: 'Acceptances',
  images: 'Images',
  countries: 'Countries',
  discarded: 'Discarded',
  topImages: 'Top Images',
  overlimit: 'Overlimit',
  schedule: 'Schedule',
  potentialImages: 'Images with Potential',
  topFlops: 'Top Flops',
  noFlops: 'No flops found 🎉',
  successByCategory: 'Results by Category',
  countriesSuccess: 'Countries (Results)',
  regionsSuccess: 'Regions (Success)',
  bestPerRegion: 'Best Image per Region',
  noData: 'No data available',

  // Bildverwaltung
  imageManagement: 'Image Management',
  imageManagementHint: 'Upload a thumbnail for each image (max. 2 MB, jpg / png / webp). It will be assigned automatically to the respective image title.',
  upload: 'Upload',
  download: 'Download',
  uploading: '⏳',
  noImage: 'no image',

  // Datenpflege
  dataMaintenance: 'Data Maintenance',
  searchTitle: 'Image Title',
  searchCompetition: 'Competition',
  clearSearch: 'Clear Search',
  warningDelete: '⚠️ Deleting records is at your own risk and permanent. Deleted data cannot be restored.',
  salon: 'Competition',
  result: 'Result',
  sessResultsLabel: 'Results / User',
  delete: 'Delete',
  confirmDelete: 'Yes, delete',
  cancel: 'Cancel',

  // Administration
  adminImport: 'Import Competition List',
  userManagement: 'User Management',
  loginLog: 'Login Log',
  editUser: 'Edit',
  deactivate: 'Deactivate',
  activate: 'Activate',
  deleteUser: 'Delete',
  createUser: 'Create New User',
  username: 'Username',
  password: 'Password',
  role: 'Role',
  create: 'Create',
  loggedIn: 'Logged In',
  loggedOut: 'Logged Out',
  duration: 'Duration',
  ip: 'IP',
  active: 'active',
  deactivated: 'deactivated',

  // Backend error messages
  errInvalidCredentials: 'Invalid credentials',
  errDeactivated: 'This account is deactivated',
  errExpired: 'This account has expired. Please contact an administrator.',
  errPasswordWrong: 'Current password is incorrect',
  errPasswordTooShort: 'New password must be at least 6 characters',
  errUsernameTaken: 'Username already taken',
  errInvalidRole: 'Invalid role',

  // Login
  loginTitle: 'Competa',
  loginBtn: 'Sign In',
  loggingIn: 'Signing in...',

  // Passwort ändern
  changePwTitle: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmPassword: 'Confirm New Password',
  changePwBtn: 'Change Password',
  // Datenpflege Tabelle
  imageTitle: 'Image Title',
  competition: 'Competition',
  land: 'Country',
  fiapNr: 'FIAP No.',
  clearSearch: 'Clear Search',
  resultsFound: 'results found',
  sessResultsLabel: 'Results / User',
  delete: 'Delete',
  newPasswordHint: 'New password (empty = unchanged)',

  // Expiry warning
  expiryWarningTitle: 'Your subscription expires in {days} day{s}.',
  expiryWarningBody: 'Please remember to renew your subscription to continue using Competa after {date}.',
  expiryWarningContact: 'To renew your subscription, please contact',
  expiryWarningBtn: 'Understood',

  // Form placeholders
  existingImageOption: '-- existing image --',
  fiapSearchPlaceholder: 'Enter name or FIAP number (min. 2 characters)...',
  fiapSearchMin: 'Enter at least 2 characters...',
  fiapSearchLoading: 'Searching...',
  fiapSearchNone: 'No salons found – competition list not imported yet?',
  salonSelected: '✅ Salon name and FIAP number applied',
  validationMsg: 'Please provide image, country, salon name and FIAP number',

};

export default en;
